export default __webpack_public_path__ + "static/media/chevron-right.37adc6d3.svg";